import React from 'react';

import InlineSelectField from '../components/InlineSelectField';

const InlineRetailerSelector = (props) => {

    const retailerOptions = props.retailers.map((retailer) => {
        return {
            id: retailer.gln,
            label: `${retailer.name} (${retailer.gln})`
        }
    });

    return (
        <InlineSelectField value={props.store ? props.store.retailer.gln : ''}
                           options={retailerOptions}
                           onCommit={props.onCommit}/>
    );
};

export default InlineRetailerSelector;



// WEBPACK FOOTER //
// ./src/admin/retailer/InlineRetailerSelector.js